// ============ PURECHA THEME JS ============
document.addEventListener('DOMContentLoaded', function() {

  // === SIZE PICKER (variant selection) ===
  document.querySelectorAll('[data-size-picker]').forEach(picker => {
    picker.querySelectorAll('.size-opt').forEach(btn => {
      btn.addEventListener('click', e => {
        if (btn.disabled || btn.classList.contains('disabled')) return;
        picker.querySelectorAll('.size-opt').forEach(b => { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        btn.classList.add('active');
        const variantId = btn.getAttribute('data-variant-id');
        const price = btn.getAttribute('data-variant-price');
        const form = btn.closest('form');
        if (form) {
          const idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = variantId;
        }
        const buyPrice = form && form.querySelector('.btn-buy .price-now');
        if (buyPrice && price) buyPrice.textContent = price;
        if (form) {
          const headline = form.querySelector('.price-block .price');
          const compare = form.querySelector('.price-was');
          if (headline) headline.textContent = price;
          if (compare) { compare.textContent = btn.dataset.variantCompare; compare.hidden = !btn.dataset.variantCompare; }
          const buy = form.querySelector('.btn-buy');
          if (buy) buy.disabled = false;
          const label = form.querySelector('[data-buy-label]');
          if (label) label.textContent = 'In den Warenkorb';
          const image = form.closest('.pdp').querySelector('.gallery .main img');
          if (image && btn.dataset.variantImage) image.src = btn.dataset.variantImage;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url);
        }
      });
    });
  });

  // === MODE PICKER (one-time vs subscribe) ===
  document.querySelectorAll('[data-mode-picker]').forEach(picker => {
    picker.querySelectorAll('.mode-opt').forEach(opt => {
      opt.addEventListener('click', () => {
        picker.querySelectorAll('.mode-opt').forEach(o => o.classList.remove('active'));
        opt.classList.add('active');
        const sellingPlanId = opt.getAttribute('data-selling-plan-id') || '';
        const form = opt.closest('form');
        if (form) {
          const planInput = form.querySelector('input[name="selling_plan"]');
          if (planInput) planInput.value = sellingPlanId;
        }
      });
    });
  });

  // === REFILL INTERVAL PICKER ===
  document.querySelectorAll('[data-refill-picker]').forEach(picker => {
    picker.querySelectorAll('.refill-pill').forEach(pill => {
      pill.addEventListener('click', e => {
        e.stopPropagation();
        picker.querySelectorAll('.refill-pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        const sellingPlanId = pill.getAttribute('data-selling-plan-id');
        const form = pill.closest('form');
        if (form && sellingPlanId) {
          const planInput = form.querySelector('input[name="selling_plan"]');
          if (planInput) planInput.value = sellingPlanId;
          const gastroMode = form.querySelector('.mode-opt.gastro');
          if (gastroMode) {
            form.querySelectorAll('.mode-opt').forEach(o => o.classList.remove('active'));
            gastroMode.classList.add('active');
          }
        }
      });
    });
  });

  // === GALLERY THUMB SWAP ===
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const main = gallery.querySelector('.main img');
    gallery.querySelectorAll('.thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.querySelector('img').getAttribute('data-full') || thumb.querySelector('img').src;
        if (main) { main.src = src; main.alt = thumb.querySelector('img').alt; }
        gallery.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  });

  // === QUANTITY ===
  document.querySelectorAll('[data-qty]').forEach(qtyWrap => {
    const span = qtyWrap.querySelector('span');
    const input = qtyWrap.closest('form') ? qtyWrap.closest('form').querySelector('input[name="quantity"]') : null;
    qtyWrap.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        let val = parseInt(span.textContent) || 1;
        val = Math.max(1, val + parseInt(btn.getAttribute('data-step')));
        span.textContent = val;
        if (input) input.value = val;
      });
    });
  });

  // === PDP MARGIN CALCULATOR (live) ===
  function formatEuro(n) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function formatInt(n) {
    return Math.round(n).toLocaleString('de-DE');
  }
  document.querySelectorAll('[data-margin-calc]').forEach(pane => {
    const cost = parseFloat(pane.getAttribute('data-cost')) || 0.50;
    const priceInput = pane.querySelector('[data-input="price"]');
    const cupsInput = pane.querySelector('[data-input="cups"]');
    const out = {
      price: pane.querySelector('[data-out="price"]'),
      cups: pane.querySelector('[data-out="cups"]'),
      cost: pane.querySelector('[data-out="cost"]'),
      markup: pane.querySelector('[data-out="markup"]'),
      weekly: pane.querySelector('[data-out="weekly"]'),
      monthly: pane.querySelector('[data-out="monthly"]'),
      marginPct: pane.querySelector('[data-out="margin-pct"]')
    };

    function updateSliderFill(input) {
      const min = parseFloat(input.min);
      const max = parseFloat(input.max);
      const val = parseFloat(input.value);
      const pct = ((val - min) / (max - min)) * 100;
      input.style.setProperty('--p', pct + '%');
    }

    function recalc() {
      const price = parseFloat(priceInput.value);
      const cups = parseInt(cupsInput.value);
      const markup = price - cost;
      const weekly = markup * cups;
      const monthly = weekly * 4;
      const marginPct = cost > 0 ? Math.round((markup / cost) * 100) : 0;

      if (out.price) out.price.textContent = formatEuro(price);
      if (out.cups) out.cups.textContent = formatInt(cups);
      if (out.cost) out.cost.textContent = formatEuro(cost);
      if (out.markup) out.markup.textContent = formatEuro(markup);
      if (out.weekly) out.weekly.textContent = formatInt(weekly) + ' €';
      if (out.monthly) out.monthly.textContent = formatInt(monthly) + ' €';
      if (out.marginPct) out.marginPct.textContent = formatInt(marginPct);

      updateSliderFill(priceInput);
      updateSliderFill(cupsInput);
    }

    if (priceInput && cupsInput) {
      priceInput.addEventListener('input', recalc);
      cupsInput.addEventListener('input', recalc);
      recalc();
    }

    // Mode tabs (Pro Tasse / Pro Woche / Pro Monat) — purely cosmetic label switch
    const modeWrap = pane.querySelector('[data-calc-mode]');
    if (modeWrap) {
      modeWrap.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
          modeWrap.querySelectorAll('button').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
        });
      });
    }
  });

  // === PDP RATIO TABS (Iced / Hot / Pur switch) ===
  document.querySelectorAll('[data-ratio-tabs]').forEach(tabWrap => {
    const card = tabWrap.closest('.pdp-ratio-card');
    if (!card) return;
    tabWrap.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.getAttribute('data-ratio-target');
        tabWrap.querySelectorAll('button').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        card.querySelectorAll('.pdp-ratio-pane').forEach(p => {
          p.classList.toggle('active', p.getAttribute('data-ratio-pane') === target);
        });
      });
    });
  });

});



// Build page-scoped option filters from the rendered products, never invented formats.
function initializeCollectionOptions() {
  const grid = document.querySelector('.ch-pgrid');
  const group = document.querySelector('[data-format-filter]');
  if (!grid || !group || group.dataset.initialized) return;
  group.dataset.initialized = 'true';
  const cards = Array.from(grid.querySelectorAll('.ch-pcard'));
  const options = new Map();
  cards.forEach(card => card.querySelectorAll('.ch-pcard-fmt').forEach((label, index) => {
    const key = card.dataset.formats.split(',').filter((v, i, a) => a.indexOf(v) === i)[index];
    if (key) options.set(key, label.textContent.trim());
  }));
  options.forEach((label, key) => {
    const button = document.createElement('button');
    button.type = 'button'; button.dataset.format = key; button.textContent = label;
    button.setAttribute('aria-pressed', 'false'); group.appendChild(button);
  });
  group.hidden = options.size < 2;
  group.addEventListener('click', event => {
    const button = event.target.closest('button[data-format]');
    if (!button) return;
    group.querySelectorAll('button').forEach(item => {
      item.classList.toggle('active', item === button);
      item.setAttribute('aria-pressed', String(item === button));
    });
    let visible = 0;
    cards.forEach(card => {
      card.hidden = button.dataset.format !== 'all' && !card.dataset.formats.split(',').includes(button.dataset.format);
      if (!card.hidden) visible++;
    });
    const count = document.querySelector('[data-format-count]');
    if (count) count.textContent = visible + (visible === 1 ? ' Produkt auf dieser Seite' : ' Produkte auf dieser Seite');
    const empty = document.querySelector('[data-format-empty]');
    if (empty) empty.hidden = visible !== 0;
  });
}
document.addEventListener('DOMContentLoaded', initializeCollectionOptions);
document.addEventListener('shopify:section:load', () => {
  const group = document.querySelector('[data-format-filter]');
  if (group) {
    group.querySelectorAll('button:not([data-format="all"])').forEach(button => button.remove());
    delete group.dataset.initialized;
  }
  initializeCollectionOptions();
});
document.addEventListener('keydown', event => {
  const thumb = event.target.closest('.thumb[role="button"]');
  if (thumb && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); thumb.click(); }
  if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => {
    menu.open = false; menu.querySelector('summary').focus();
  });
});
